angular.module('lf.common')

.directive('validEmails', function (validationService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, el, attrs, model) {
      var separator = attrs.validMultipleEmail || ',';
      var validator = function (val) {
        var valid = !model.$isEmpty(val);
        if (valid) {
          var emailAddresses = val.split(separator);
          for (var i = 0; i < emailAddresses.length; i++) {
            if (!validationService.validateEmail(emailAddresses[i])) {
              valid = false;
              break;
            }
          }
        }
        model.$setValidity('validEmails', valid);
        return val;
      }
      model.$parsers.push(validator);
      model.$formatters.push(validator);
    }
  }
});
